
import React from 'react';

interface ReferralProgressProps {
  invitedCount: number;
}

export const ReferralProgress = ({ invitedCount }: ReferralProgressProps) => {
  return (
    <div className="bg-accent/50 p-4 rounded-lg">
      <p className="text-sm font-medium text-center text-foreground">
        {invitedCount}/10 friends invited in current round
      </p>
      <div className="w-full bg-muted rounded-full h-2.5 mt-2">
        <div 
          className="bg-primary h-2.5 rounded-full transition-all duration-500"
          style={{ width: `${(invitedCount / 10) * 100}%` }}
        />
      </div>
    </div>
  );
};
